import React from "react";

const ShiftAllowanceCode = () => {
    return <div>ShiftAllowanceCode</div>;
}

export default ShiftAllowanceCode;